const getYoutubeVideoId = (youtubeURL) => youtubeURL.split('?v=').pop();

export default getYoutubeVideoId;
